import items from './items'

export default {
  postForgotPassword(email) {
    return items.createItem('auth/forgot_password', { email })
  },
  logout() {
    return items.getItem('auth/logout')
  },
  isAuthenticated() {
    return items.getItem('auth/is_authenticated')
  },
}
